import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState, AILoaderState } from './loader-state';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();

  private ailoaderSubject = new Subject<AILoaderState>();
  aiLoaderState = this.ailoaderSubject.asObservable();
  

  constructor() { }
  show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }
  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

  showAILoader() {
    this.ailoaderSubject.next(<AILoaderState>{ showAI: true });
  }
  hideAILoader() {
    this.ailoaderSubject.next(<AILoaderState>{ showAI: false });
  }


}
